import { useContext } from "react";
import { Separator } from "@moreirapontocom/npmhelpers";
import { Link } from "react-router-dom";
import { DataContext } from "../../context/Data.context";

import "./Navbar.component.scss";

const Navbar = () => {
  const { data } = useContext(DataContext);

  return <>
    {!data.hideNavbar && <>
      <nav className="Navbar navbar navbar-expand-lg fixed-bottom bg-body-tertiary">
        <div className="container-fluid">

          <div className="list-group list-group-horizontal">
            <Link to={"/home"} className="list-group-item">
              <i className="fas fa-home"></i>
              <Separator size={5} />
              Home
            </Link>
            <Link to={"listProfiles"} className="list-group-item">
              <i className="fas fa-user-circle"></i>
              <Separator size={5} />
              Profiles
            </Link>
            <Link to={"readers"} className="list-group-item">
              <i className="fas fa-suitcase"></i>
              <Separator size={5} />
              Readers
            </Link>
            <Link to={"/help"} className="list-group-item">
              <i className="fas fa-question-circle"></i>
              <Separator size={5} />
              Help
            </Link>
            <Link to={"/temp"} className="list-group-item">
              <i className="fas fa-shopping-cart"></i>
              <Separator size={5} />
              Shop
            </Link>
          </div>

        </div>
      </nav>
    </>}
  </>
};

export default Navbar;